module.exports = __webpack_public_path__ + "static/media/idlepage-chat.306dd835.svg";